module.exports = __webpack_public_path__ + "static/media/closeEnvelope.6540a13b.svg";